<template>
    <div id="navbar" class="fixed-top">
        <a class="float-left nav-brand" href="/#"><img class="maximum-height" src="../assets/icons/logo.png"></a>
        <nav class="children-vertical-center" v-bind:class="{'navbar-show': displayNav}">
            <a href="/">Home</a>
            <a href="/#/about">About Us</a>
            <a href="/#/services">Services</a>
            <a href="/#/contact">Contact Us</a>
        </nav>
        <div class="mobile-nav-button d-m float-right" @click="displaySwitch">
          <img class="maximum-height" src="../assets/icons/Hamburger_icon.svg.png" />
        </div>
    </div>
</template>
<script>
export default {
  name: 'navbar',
  data () {
    return {
      displayNav: false
    }
  },
  methods: {
    displaySwitch () {
      this.displayNav = !this.displayNav
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Navbar.vue